module.exports = __webpack_public_path__ + "static/media/TheSecretWorldofBriarRose.ca380d0b.jpg";